/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Proof_5_VInputs */

const en_mk_proof_5_v = /** @type {(inputs: Mk_Proof_5_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 languages`)
};

const id_mk_proof_5_v = /** @type {(inputs: Mk_Proof_5_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 bahasa`)
};

/**
* | output |
* | --- |
* | "2 languages" |
*
* @param {Mk_Proof_5_VInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_proof_5_v = /** @type {((inputs?: Mk_Proof_5_VInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Proof_5_VInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_proof_5_v(inputs)
	return en_mk_proof_5_v(inputs)
});